import { Container, ContainerGutter, ContainerPadding, styled, Text, TokenTextAppearance } from '@volkswagen-onehub/components-core';
import React from 'react';

interface LegendInterface {
    legend: string,
    headline?: string
}

const CustomFieldSet = styled.fieldset`
    border: 3px solid ${props => props.theme.colors.border.hover};
`

const CustomLegend = styled.legend`
    padding: 0 ${props => props.theme.size.static150} 0 ${props => props.theme.size.static150};
    font-size: ${props => props.theme.size.static250};
`

const BuildPriceFieldset = (props: React.PropsWithChildren<LegendInterface>) => {

    return (
        <CustomFieldSet>
            <CustomLegend>{props.legend}</CustomLegend>

            <Container
                padding={{
                    top: ContainerPadding.static200,
                    left: ContainerPadding.static150,
                    bottom: ContainerPadding.static200,
                    right: ContainerPadding.static150
                }}
                wrap="always"
                gutter={ContainerGutter.static200}>
                    {props.headline &&
                        <Container wrap="always">
                            <Text appearance={TokenTextAppearance.headline200} bold>{props.headline}</Text>
                        </Container>
                    }

                    {props.children}
            </Container>
        </CustomFieldSet>
    );

}

export default BuildPriceFieldset;
